import { useEffect, useState } from 'react';
import { db } from '../lib/firebase';
import { subscribeUserThreads, type ThreadListItem } from '../services/thesconAiThreads';

/** Live list of the signed-in user's threads (newest first). */
export function useThesconAiThreadsList(userId: string | undefined, maxThreads = 40) {
  const [threads, setThreads] = useState<ThreadListItem[]>([]);

  useEffect(() => {
    if (!userId) {
      setThreads([]);
      return undefined;
    }
    return subscribeUserThreads(db, userId, maxThreads, setThreads);
  }, [userId, maxThreads]);

  return threads;
}
